import Modalerror from './modalError';
import { SIZE } from './constants';

export default Modalerror;
export { SIZE };